<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Datos de la Tarjeta">
          <b-form>
            <b-form-group
              label="Banco"
              label-for="banco"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="banco" 
                :value="banco" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Tarjeta"
              label-for="tarjetaMarca"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="tarjetaMarca" 
                :value="tarjetaMarca" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nro.Cuenta"
              label-for="numeroCuenta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroCuenta" 
                :value="numeroCuenta" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Vencimientos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="tarjetasResumenes" 
              :fields="tarjetasResumenesFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaCierre)="data">
              {{ data.item.fechaCierre | fecha }}
            </template>
            <template v-slot:cell(fechaVencimiento)="data">
              {{ data.item.fechaVencimiento | fecha }}
            </template>

            <!-- <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-edit"></i>Borrar Resumen</b-dropdown-item>
              </b-dropdown>
            </template> -->
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div> -->

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Agregar Nuevo Vencimiento</b-dropdown-item>

          <b-dropdown-item @click.stop="borrar">
            <i class="fa fa-remove"></i>Eliminar Último Vencimiento</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado de Tarjetas</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetasResumenes/getField',
  mutationType: 'tarjetasResumenes/updateField',
});

export default {
  name:'TarjetasResumenes',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      tarjetasResumenesFields: [
        // {
        //   key: 'tarjetaBanco',
        //   label: 'Banco',
        // },
        // {
        //   key: 'tarjeta',
        //   label: 'Tarjeta',
        // },
        // {
        //   key: 'tarjetaTitular',
        //   label: 'Titular',
        // },
        {
          key: 'fechaCierre',
        },
        {
          key: 'fechaVencimiento',
        },
        // { 
        //   key: 'opciones',
        //   label: '',
        //   class:'text-center'
        // },
      ],

      tableBusy: false,
      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'tarjetaId',
      'banco',
      'tarjetaMarca',
      'numeroCuenta',

      'tarjetasResumenes',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    let tarjetaId= this.$route.params.tarjetaId

    this.$store.dispatch('tarjetasResumenes/inicializar', tarjetaId)
      .then(() => this.getItems())
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    filtrar() {
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('tarjetasResumenes/getTarjetasResumenes')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'TarjetaVencimientoData', 
                          params: { id: item.id }});
    },
    agregar () {
      if (this.tarjetaId != 0) {
        this.$router.push({ name: 'TarjetaVencimientoAdd',
                            params: { tarjetaId: this.tarjetaId }});
      }
    },
    borrar () {
      if (this.tarjetaId != 0) {
        this.showModalConfirm('¿Desea eliminar el último vencimiento de la tarjeta?', 
              this.borrarTarjetaResumen, 'Si', null, 'No')
      }
    },
    borrarTarjetaResumen () {
      this.showSpinner();
      this.$store.dispatch('tarjetasResumenes/delete')
        .then(() => this.showModalMsj('El último vencimiento se eliminó con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goBack () {
      this.$router.push({ name: 'Tarjetas' });
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
